import React, { FC } from "react";

import FlexContainer from "@/components/FlexContainer";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

import {
    StyledDashboardCollapse,
    StyledDashboardCollapseList,
    StyledDashboardCollapseListItem,
    StyledInfoIcon,
} from "./Styled";

export type DashboardCollapseItemType =
    | "basic"
    | "fin_groups"
    | "progressive_scale"
    | "sequential_scale";

export interface DashboardCollapseListItem {
    label: string;
    value: string | number;
    type: DashboardCollapseItemType;
}

interface IDashboardCollapse {
    header: React.ReactNode;
    items: DashboardCollapseListItem[];
    onInfoClick?: (type: DashboardCollapseItemType) => void;
}

export const DashboardCollapse: FC<IDashboardCollapse> = ({
    header,
    items,
    onInfoClick,
}) => {
    const renderValue = (
        value: string | number,
        type: DashboardCollapseItemType,
    ) => {
        const shouldShowInfoIcon = type !== "basic";

        return (
            <FlexContainer gap="12px" alignItems="center">
                <PrimaryText fontSize={14} fontWeight="500">
                    {value}
                </PrimaryText>

                {shouldShowInfoIcon && (
                    <StyledInfoIcon onClick={() => onInfoClick?.(type)} />
                )}
            </FlexContainer>
        );
    };

    const renderListItem = ({
        label,
        value,
        type,
    }: DashboardCollapseListItem) => (
        <StyledDashboardCollapseListItem key={`${label}-${type}`}>
            <SecondaryText fontSize={14} fontWeight="400" $textNoWrap>
                {label}
            </SecondaryText>

            {renderValue(value, type)}
        </StyledDashboardCollapseListItem>
    );

    return (
        <StyledDashboardCollapse
            items={[
                {
                    label: header,
                    children: (
                        <StyledDashboardCollapseList>
                            {items.map(renderListItem)}
                        </StyledDashboardCollapseList>
                    ),
                },
            ]}
        />
    );
};
